import { gql, useLazyQuery } from '@apollo/client';
import { SwiftSuggestion as Query, SwiftSuggestionVariables as Variables } from './hooks.types';

const query = gql`
  query SwiftSuggestion($substring: String!) {
    clearing {
      abroadBankInfoList(query: $substring) {
        swift
        name
        address
      }
    }
  }
`;

export const useSuggestion = () => {
  const [fetch, { data, loading }] = useLazyQuery<Query, Variables>(query);

  return {
    loading,
    list: data?.clearing?.abroadBankInfoList || [],
    onChange: (value: string) => value && fetch({ variables: { substring: value } }),
  };
};
